import { Component } from '@angular/core';

@Component({
  selector: 'app-setting-icon',
  imports: [],
  templateUrl: './setting-icon.html',
  styleUrl: './setting-icon.css'
})
export class SettingIcon {

}
